<template>
    <common-content-spacer height="medium">
        <common-content-spacer height="small">
            <common-breadcrumbs :breadcrumbs="pageBreadcrumbs"></common-breadcrumbs>
            <common-page-header :heading="pageTitle"></common-page-header>
        </common-content-spacer>
        <common-loader :isProcessing="isSending"></common-loader>
        <common-page-plain v-if="referrals.length && !isSending">
            <common-content-spacer height="medium">
                <temporary-referrals-index-listing :referrals="referrals"></temporary-referrals-index-listing>
                <common-buttons>
                    <common-button
                        v-if="referrals.length < referralsTotalCount"
                        :isProcessing="isProcessing"
                        :label="$t('pages.referrals.index.buttons.show_more')"
                        type="primary"
                        size="large"
                        @click="showMore()"
                    ></common-button>
                </common-buttons>
            </common-content-spacer>
        </common-page-plain>
        <div v-if="!referrals.length && !isSending">{{ $t('pages.referrals.index.empty_state.no_referrals') }}</div>
    </common-content-spacer>
</template>

<script>
    import PageWithTitleMixin from 'mixins/PageWithTitleMixin'
    import PageWithElementsMixin from 'mixins/PageWithElementsMixin'
    import PageWithDataMixin from 'mixins/PageWithDataMixin'
    import TemporaryReferralsIndexListing from 'components/page-elements/temporary-referrals/TemporaryReferralsIndexListing'
    import TemporaryReferralsAPI from 'api/TemporaryReferralsAPI'

    export default {
        mixins: [PageWithTitleMixin, PageWithElementsMixin, PageWithDataMixin],

        components: {
            TemporaryReferralsIndexListing,
        },

        data() {
            return {
                referrals: [],
                isSending: false,
                isProcessing: false,
                referralsTotalCount: 0,
            }
        },

        computed: {
            pageTitle() {
                return this.$t(`pages.referrals.index.titles.${this.$route.params.type}`)
            },

            pageBreadcrumbs() {
                return [
                    {
                        label: this.$t('pages.referrals.index.breadcrumbs.referrals'),
                        route: { name: `referrals.${this.$route.params.type}.referrals` },
                    },
                    { label: this.$t(`pages.referrals.index.breadcrumbs.${this.$route.params.type}`) },
                ]
            },
        },

        methods: {
            loadReferrals(append) {
                if (!append) {
                    this.isSending = true
                } else {
                    this.isProcessing = true
                }

                TemporaryReferralsAPI.getList()
                    .then((res) => {
                        this.referralsTotalCount = res._headers['x-total-count']
                        this.referrals = res
                    })
                    .finally(() => {
                        this.isSending = false
                        this.isProcessing = false
                    })
            },
        },

        watch: {
            referrals() {
                if (this.referrals._headers) {
                    this.referralsTotalCount = this.referrals._headers['x-total-count']
                }
            },
        },

        mounted() {
            this.loadReferrals()
        },
    }
</script>
